import React, { useEffect, useState } from 'react';
import { Button, OutlineButton } from '../styles/Hero.styles.js';
import { Text } from '@chakra-ui/core';
import { openBooking, openTasks } from '../HomePage/Hero';
import styled from 'styled-components';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  color: #373744;
`;

const GreenDot = styled.span`
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  display: inline-block;

  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
      transform: scale(0.8);
    }
  }
`;

const HeroHeadline = styled.h1`
  font-size: 4rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  line-height: 1.1;
  margin: 0 0 1.5rem 0;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const BlueText = styled.span`
  color: #1d4ed8;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const StatsContainer = styled.div`
  display: flex;
  gap: 4rem;
  margin-top: 4rem;

  @media (max-width: 768px) {
    gap: 2rem;
  }
`;

const StatItem = styled.div`
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1d4ed8;
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const StatLabel = styled.div`
  font-size: 0.95rem;
  color: #666;
`;

export default function Hero() {
  const [width, setWidth] = useState(window.innerWidth);

  let _setWidth = () => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', _setWidth);
    return () => {
      window.removeEventListener('resize', _setWidth);
    };
  }, []);

  const urlParams = new URLSearchParams(window.location.search);

  const building = urlParams.get('building');

  return (
    <section className="hero" id="hero">
      <div
        className="container"
        style={{
          position: 'relative',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80dvh',
        }}
      >
        <Badge>
          <GreenDot />
          Available for residents {building ? `of ${building}` : 'only'}
        </Badge>

        <HeroHeadline>
          Never clean
          <br />
          <BlueText>your home again.</BlueText>
        </HeroHeadline>

        <Text
          fontSize="1rem"
          color="#666"
          maxW="700px"
          margin="0 auto"
          lineHeight="1.6"
        >
          Professional cleaning with building access coordination.
          {width > 600 ? <br /> : <>&nbsp;</>}
          Book instantly, pay per task, no minimums.
        </Text>

        <ButtonGroup>
          <Button
            onClick={() => openBooking(undefined, 'residents')}
            style={{ padding: '0.5rem 1.5rem', fontSize: '1rem' }}
          >
            Build my plan →
          </Button>
          <OutlineButton
            onClick={() => {
              openTasks(undefined, 'residents-task');
            }}
            style={{ padding: '0.5rem 1.5rem', fontSize: '1rem' }}
          >
            Book a task →
          </OutlineButton>
        </ButtonGroup>

        <StatsContainer>
          <StatItem>
            <StatNumber>100%</StatNumber>
            <StatLabel>Verified cleaners</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>2500+</StatNumber>
            <StatLabel>Residents served</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>4.9/5</StatNumber>
            <StatLabel>Resident rating</StatLabel>
          </StatItem>
        </StatsContainer>
      </div>
    </section>
  );
}
